export default __webpack_public_path__ + "static/media/lastminute.86f27656.png";